import { Head, useForm, Link } from '@inertiajs/react'
import { useState } from 'react'
import Input from '../../components/ui/Input'
import Button from '../../components/ui/Button'

/**
 * ForgotPassword page - Request password reset
 * Route: GET /identity/password-reset/new
 * Form submits to: POST /identity/password-reset
 */
export default function ForgotPassword() {
  const { data, setData, post, processing, errors } = useForm({
    email: ''
  })

  const [emailSent, setEmailSent] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    post('/identity/password_reset', {
      onSuccess: () => {
        setEmailSent(true)
      }
    })
  }

  if (emailSent) {
    return (
      <>
        <Head title="Email envoyé" />

        <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
          <div className="max-w-md w-full space-y-8">
            {/* Success message */}
            <div className="text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
                <svg
                  className="h-6 w-6 text-green-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>

              <h2 className="text-3xl font-extrabold text-gray-900 mb-2">
                Email envoyé !
              </h2>

              <p className="text-sm text-gray-600 mb-8">
                Si un compte existe avec l'adresse <strong>{data.email}</strong>,
                vous recevrez un email avec les instructions pour réinitialiser votre mot de passe.
              </p>

              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
                <p className="text-sm text-blue-800">
                  <strong>Astuce :</strong> Vérifiez aussi vos spams si vous ne voyez pas l'email dans votre boîte de réception.
                </p>
              </div>

              <Link
                href="/sign-in"
                className="inline-flex items-center text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
              >
                <svg
                  className="mr-2 h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                Retour à la connexion
              </Link>
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <Head title="Mot de passe oublié" />

      <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          {/* Header */}
          <div>
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
              Mot de passe oublié ?
            </h2>
            <p className="mt-2 text-center text-sm text-gray-600">
              Entrez votre email et nous vous enverrons un lien pour réinitialiser votre mot de passe
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="mt-8 space-y-6">
            <Input
              label="Email"
              type="email"
              name="email"
              value={data.email}
              onChange={(e) => setData('email', e.target.value)}
              error={errors.email}
              required
              autoFocus
              placeholder="vous@example.com"
            />

            {/* Submit button */}
            <Button
              type="submit"
              variant="primary"
              size="lg"
              className="w-full"
              disabled={processing}
              loading={processing}
            >
              Envoyer le lien de réinitialisation
            </Button>

            {/* Back to sign in */}
            <div className="text-center">
              <Link
                href="/sign-in"
                className="inline-flex items-center text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
              >
                <svg
                  className="mr-2 h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                Retour à la connexion
              </Link>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}
